import React, { useContext, useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { ClassifiedDiff } from 'src/components/diff-set/classified-diff';
import { DiffMetadataProps } from 'src/components/diff-set/diff-set';
import { DIFFS_HAVE_RENDERED } from 'src/redux/pull-request/actions';
import { DiffFeaturesContext } from 'src/sections/repository/sections/pull-request/components/diff-features-context';
import * as styles from 'src/sections/repository/sections/pull-request/components/diff-set.styled';
import { SingleFileModeExplanation } from 'src/sections/repository/sections/pull-request/components/single-file-mode/single-file-mode-explanation';
import { Diff } from 'src/types/pull-request';
import { extractFilepath } from 'src/utils/extract-file-path';
import { getFileHref } from 'src/utils/get-file-href';

import { useAnchorTopOffset } from './hooks/diff-set-details';

type SingleFileDiffListProps = {
  file: Diff;
  diffMetadataProps: DiffMetadataProps;
  isGlobalSingleFileModeEnabled: boolean;
};

export const SingleFileDiffList = ({
  file,
  diffMetadataProps,
  isGlobalSingleFileModeEnabled,
}: SingleFileDiffListProps) => {
  const { hasCommentNav } = useContext(DiffFeaturesContext);
  const anchorTopOffset = useAnchorTopOffset();
  const filepath = extractFilepath(file);
  const fileHref = getFileHref(filepath);

  const dispatch = useDispatch();

  // File is required in the dependencies to trigger the action when the user uses
  // comment navigation to push to a different file
  useEffect(() => {
    dispatch({ type: DIFFS_HAVE_RENDERED });
  }, [file, dispatch]);

  return (
    <styles.DiffSetFileWrapper
      isSingleFileModeActive
      hasCommentNav={hasCommentNav}
    >
      <styles.ScrollToAnchor
        topOffset={anchorTopOffset}
        id={fileHref}
        hasCommentNav={hasCommentNav}
      />
      <ClassifiedDiff
        file={file}
        diffMetadataProps={diffMetadataProps}
        index={0}
      />
      {!isGlobalSingleFileModeEnabled && (
        <SingleFileModeExplanation position="footer" />
      )}
    </styles.DiffSetFileWrapper>
  );
};
